// Path: frontend/src/lib/api/progress.ts
// 研发进度跟踪 API 模块

import { api } from './core';

// ==========================================
// 📚 Type Definitions
// ==========================================

export interface PlanProgress {
  plan_id: number;
  version_number: string;
  created_by: number;
  creator_name: string;
  content_length: number;
  is_final: boolean;
  plan_tokens: number;
  plan_cost_rmb: number;
}

export interface SlideProgress {
  completed_slides: number;
  total_slide_indices: number;
  slide_tokens: number;
  slide_cost_rmb: number;
}

export interface LessonProgress {
  lesson_id: number;
  lesson_title: string;
  sort_order?: number;
  plan_progress: PlanProgress | null;
  slide_progress: SlideProgress | null;
  total_tokens: number;
  total_cost_rmb: number;
  daily_tokens: number;
  daily_cost_rmb: number;
}

export interface StageProgress {
  stage_id: number;
  stage_title: string;
  lessons: LessonProgress[];
  stage_total_tokens: number;
  stage_total_cost_rmb: number;
  daily_tokens: number;
  daily_cost_rmb: number;
}

export interface CourseProgress {
  course_id: number;
  course_title: string;
  stages: StageProgress[];
  course_total_tokens: number;
  course_total_cost_rmb: number;
  daily_tokens: number;
  daily_cost_rmb: number;
}

// ==========================================
// 🔌 API Functions
// ==========================================

const formatDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const getCourseProgress = async (courseId: number, queryDate?: Date): Promise<CourseProgress> => {
  const params = queryDate ? { query_date: formatDate(queryDate) } : {};
  const response = await api.get<CourseProgress>(`/progress/course/${courseId}`, { params });
  return response.data;
};

export const getStageProgress = async (stageId: number, queryDate?: Date): Promise<StageProgress> => {
  const params = queryDate ? { query_date: formatDate(queryDate) } : {};
  const response = await api.get<StageProgress>(`/progress/stage/${stageId}`, { params });
  return response.data;
};

export const getLessonProgress = async (lessonId: number, queryDate?: Date): Promise<LessonProgress> => {
  const params = queryDate ? { query_date: formatDate(queryDate) } : {};
  const response = await api.get<LessonProgress>(`/progress/lesson/${lessonId}`, { params });
  return response.data;
};
